
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatTableDataSource } from '@angular/material/table'
import { MatchedOffer } from '@tradecafe/types/core'
import { FutureBidsListModule } from 'src/components/future-bids-list/future-bids-list.module'
import { FutureBidRow2, FUTURE_BIDS_COLUMN_NAMES } from 'src/components/future-bids-list/future-bids-list.columns'
import { FutureBidsApiService, FutureBidDataInput } from 'src/pages/admin/auction/future-bids/future-bids.service'

export interface FutureBidsListOverlayOptions {
  row: {
    doc: MatchedOffer
    future_bids: {
      bids: FutureBidDataInput[]
    }
    delivery?: {
      name?: string
    }
  }
}

@Component({
  selector: 'tc-future-bids-list-overlay',
  templateUrl: './future-bids-list-overlay.component.html',
  styleUrls: ['./future-bids-list-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    FutureBidsListModule
],
})
export class FutureBidsListOverlayComponent implements OnInit {
  dialogData = inject<FutureBidsListOverlayOptions>(MAT_DIALOG_DATA)
  private readonly dialogRef = inject<MatDialogRef<FutureBidsListOverlayComponent, void>>(MatDialogRef)
  private readonly cdr = inject(ChangeDetectorRef)
  private readonly futureBidsApiService = inject(FutureBidsApiService)

  dataSource = new MatTableDataSource<FutureBidRow2>()

  displayColumns: string[] = [
    'matched_offer_id',
    'buyer_price',
    'offer_price',
    'fob_price',
    'price',
    'futureDates',
    'shipmentDates',
    'deliveryLocation',
    'updated',
    'actionMenu'
  ]

  columnNames = {
    ...FUTURE_BIDS_COLUMN_NAMES,
    futureDates: 'Future Delivery Date'  // Override to match original overlay
  }

  async ngOnInit(): Promise<void> {
    const bids = this.dialogData?.row?.future_bids?.bids || []
    const matchedOffer = this.dialogData?.row?.doc
    const deliveryLocationName = this.dialogData?.row?.delivery?.name

    // Use shared service method to transform bids
    this.dataSource.data = this.futureBidsApiService.transformBidsToRows(bids, {
      fallbackMatchedOffer: matchedOffer,
      fallbackDeliveryLocationName: deliveryLocationName
    })
    this.cdr.markForCheck()
  }

  close(): void {
    this.dialogRef.close()
  }

  onListChange(): void {
    this.cdr.markForCheck()
  }
}